import { FC, useEffect, useState } from 'react';
import { ICandidate, IJob } from 'wisestep-api';
import { WsDrawer } from 'wisestep-base';

import { MapAsSubmission } from '../../jobs/listing/components/mapAsSubmission';

import JobSelection from './JobSelection';

const SubmitCandidate: FC<{
  candidate: ICandidate | null;
  job: IJob | null;
  close: () => void;
  openSubmitCandidate: boolean;
}> = ({ candidate, job, close, openSubmitCandidate }) => {
  const [jobEntity, setJobEntity] = useState<IJob | null>(null);
  const [isMapasSubmission, setMapasSubmission] = useState<boolean>(true);

  useEffect(() => setJobEntity(job), [job]);

  const closeModal = () => close();
  const removeSelectedJob = () => setMapasSubmission(false);
  const addSelectedJob = () => setMapasSubmission(true);

  const prepareCandidate = (candidate: ICandidate) => {
    const preparedCandidate = candidate;
    preparedCandidate.jobAccountManagerEmail = null;
    preparedCandidate.jobAccountManagerName = candidate.jobAccountManagerName;
    preparedCandidate.jobClientRecruiterEmail = null;
    preparedCandidate.jobClientRecruiterName = candidate.jobClientRecruiterName;
    preparedCandidate.jobCode = null;
    preparedCandidate.jobWorkAssignment = null;
    preparedCandidate.jobType = null;
    preparedCandidate.workPermitDocuments = null;
    preparedCandidate.workPermitLocations = null;
    preparedCandidate.workPermits = null;
    preparedCandidate.workPreferences = null;
    preparedCandidate.workspaceId = null;
    preparedCandidate.workspaceName = null;
    return preparedCandidate;
  };
  return (
    <WsDrawer
      style={{ zIndex: '1300' }}
      size="medium"
      hideHeader={true}
      open={openSubmitCandidate}
      onClose={() => closeModal}
      hideOverflow={true}
    >
      {jobEntity && isMapasSubmission ? (
        <MapAsSubmission
          selectedJob={jobEntity}
          onClose={() => close()}
          selectedCandidate={candidate ? prepareCandidate(candidate) : undefined}
          hideJobSelection={false}
          setRemove={removeSelectedJob}
        />
      ) : (
        <JobSelection
          getJob={(job) => {
            setJobEntity(job);
          }}
          job={null}
          onBackButton={closeModal}
          showMapSubmission={addSelectedJob}
        />
      )}
    </WsDrawer>
  );
};

export default SubmitCandidate;
